/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "climate-tornado-b91b50f8--sprite",
  "use": "climate-tornado-b91b50f8--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"climate-tornado-b91b50f8--sprite\"><g fill=\"#fff\" stroke=\"#e5ebf6\" stroke-width=\"1\" opacity=\"0\"><rect width=\"36\" height=\"36\" stroke=\"none\" /><rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" fill=\"none\" /></g><g transform=\"translate(3 2)\"><path d=\"M18.339,14.668a.159.159,0,0,1-.159.159h-.4V16.18c0,.239-.08.318-.159.318H15.316c-.08,0-.159-.08-.159-.318V14.827h-.4c-.159,0-.159-.08-.159-.159a.318.318,0,0,1,.159-.318l1.511-1.75h.4l.716.8V13l.159-.159H17.7l.239.159v1.034l.239.318a.4.4,0,0,1,.159.318Z\" transform=\"translate(3.4 2.896)\" fill=\"currentColor\" /><path d=\"M27.461,20.423a4.961,4.961,0,0,0-.692-2.538c-3.923-.115-8.077-.462-9.923-1.154a60.115,60.115,0,0,0,9.115,0c-.923-1.038-1.731-1.615-1.5-2.654-4.615.346-11.308-.115-13.731-1.038a69,69,0,0,0,14.654-.577l1.269-2.192c-6.231.692-16.961-.115-20.769-2.077a79.037,79.037,0,0,0,22.154-.808A6,6,0,0,0,30,2.885C30,1.269,23.307,0,15,0S0,1.269,0,2.885,1.385,12,7.038,14.538s11.423,5.077,11.423,7.615S7.038,25.961,14.192,32.307c0,0-.346-3.808,2.308-4.615s10.269-1.731,10.961-6.115a18.692,18.692,0,0,1-6.692-1.269,43.268,43.268,0,0,0,6.692.115ZM7.269,3.115c0-.692,3.808-1.269,8.423-1.269s8.538.577,8.538,1.269c-.231.692-3.808,1.269-8.538,1.269S7.269,3.808,7.269,3.115Z\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
